/**
 * Applies per-section product card appearance classes.
 * Curves, card border, and offset are independent.
 */
(function () {
  'use strict';

  const CLASSES = [
    'product-item--has-card-border',
    'product-item--has-curves',
    'product-item--has-offset',
    'product-item--curve-tl',
    'product-item--curve-tr',
  ];
  const PRODUCT_ITEM_SELECTOR = 'grid-item.product-item, .product-item.grid-item';
  const GRID_SELECTOR = '.grid--slider, .grid--mobile-slider, .grid, .look__slider, .hero__products.grid';

  function resolveCorners(index, total, isSlider, setting, showCurves) {
    let tl = false;
    let tr = false;

    if (!showCurves) {
      return { tl, tr };
    }

    if (isSlider) {
      if (total <= 1) {
        tl = true;
        tr = true;
      } else if (index === 0) {
        if (setting === 'left_top' || setting === 'both') tl = true;
      } else if (index === total - 1) {
        if (setting === 'right_top' || setting === 'both') tr = true;
      }
    } else {
      if (setting === 'left_top') tl = true;
      else if (setting === 'right_top') tr = true;
      else if (setting === 'both') {
        tl = true;
        tr = true;
      }
    }

    return { tl, tr };
  }

  function getSettingsContainer(container) {
    if (container?.hasAttribute('data-product-show-curves')) {
      return container;
    }

    return container?.closest('[data-product-show-curves]') || container;
  }

  function applyToItem(item, index, total, isSlider, container) {
    const settingsEl = getSettingsContainer(container);
    const showCurves = settingsEl?.dataset?.productShowCurves === 'true';
    const showBorder = settingsEl?.dataset?.productShowCardBorder === 'true';
    const showOffset = settingsEl?.dataset?.productShowOffset === 'true';
    const setting = settingsEl?.dataset?.productCurveCorners || 'right_top';

    if (!showCurves && !showBorder && !showOffset) {
      item.classList.remove(...CLASSES);
      return;
    }

    const { tl, tr } = resolveCorners(index, total, isSlider, setting, showCurves);

    item.classList.remove(...CLASSES);

    if (showBorder) item.classList.add('product-item--has-card-border');
    if (showCurves && tl) item.classList.add('product-item--curve-tl');
    if (showCurves && tr) item.classList.add('product-item--curve-tr');
    if (showCurves && (tl || tr)) item.classList.add('product-item--has-curves');
    if (showOffset) item.classList.add('product-item--has-offset');
  }

  function getDirectProductItems(container) {
    return Array.from(container.children).filter((child) => child.matches(PRODUCT_ITEM_SELECTOR));
  }

  function isSliderContainer(container) {
    return container.classList.contains('grid--slider') || container.classList.contains('grid--mobile-slider');
  }

  function applyToContainer(container) {
    const settingsEl = getSettingsContainer(container);

    if (
      settingsEl?.dataset?.productShowCurves !== 'true' &&
      settingsEl?.dataset?.productShowCardBorder !== 'true' &&
      settingsEl?.dataset?.productShowOffset !== 'true'
    ) {
      return;
    }

    const items = getDirectProductItems(container);
    if (!items.length) return;

    const isSlider = isSliderContainer(container);
    items.forEach((item, index) => applyToItem(item, index, items.length, isSlider, settingsEl));
  }

  function applyAll() {
    document.querySelectorAll(GRID_SELECTOR).forEach(applyToContainer);
  }

  let scheduled = false;

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  }

  document.addEventListener('DOMContentLoaded', applyAll);
  document.addEventListener('theme:recently-viewed:loaded', applyAll);
  document.addEventListener('theme:html:change', scheduleApply);
  document.addEventListener('shopify:section:load', scheduleApply);

  if (document.readyState !== 'loading') {
    applyAll();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        scheduleApply();
        break;
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
